// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"bc4d6049","513":"e86d822c","703":"939abfae"}[chunkId] + ".chunk.js";
};